import { render, staticRenderFns } from "./userCover.vue?vue&type=template&id=3ff46433&scoped=true&"
import script from "./userCover.vue?vue&type=script&lang=js&"
export * from "./userCover.vue?vue&type=script&lang=js&"
import style0 from "./userCover.vue?vue&type=style&index=0&id=3ff46433&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff46433",
  null
  
)

export default component.exports